import { useState, useEffect } from "react";

function truncateDecimals(num: number, decimals: number) {
  const factor = Math.pow(10, decimals);
  return Math.floor(num * factor) / factor;
}

export default function AnimatedNumber({
  value,
  duration = 800,
  className = "",
}: {
  value: number;
  duration?: number;
  className?: string;
}) {
  const [display, setDisplay] = useState(0);

  // detect decimals from input
  const decimalCount = value.toString().includes(".")
    ? value.toString().split(".")[1].length
    : 0;

  useEffect(() => {
    const start = display;
    const startTime = performance.now();

    const animate = (time: number) => {
      const elapsed = time - startTime;
      const progress = Math.min(elapsed / duration, 1);

      const current = start + (value - start) * progress;
      const truncated = truncateDecimals(current, decimalCount);

      setDisplay(truncated);

      if (progress < 1) requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);
  }, [value]);

  return (
    <span className={className}>
      {display.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: decimalCount,
      })}
    </span>
  );
}
